import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class ConfigService {
  private BASE_URL = environment.serverUrl + 'config';

  constructor(private http: HttpClient) { }

  public getNodejsUrl(): Observable<string> {
    return this.http.get(this.BASE_URL + '/nodejsurl')
      .pipe(
        map(r => r as string)
      );
  }

  public getBlogUrl(): Observable<string> {
    return this.http.get(this.BASE_URL + '/blogurl')
      .pipe(
        map(r => r as string)
      );
  }
}
